import RippleAvatar from './RippleAvatar';
import './typingIndicator.scss';

const TypingIndicator = () => {
  return (
    <div className="chat-typing-indicator">
      <div className="chat-typing-indicator__header">
        <RippleAvatar size="lg" />
        <span className="chat-typing-indicator__name">EndoZoneAI</span>
      </div>
      <div className="chat-typing-indicator__bar" />
    </div>
  );
};

export default TypingIndicator;
